import { PageTitle, useLayout } from "../../../_metronic/layout/core";
import { DefaultTitle } from "../../../_metronic/layout/components/header/page-title/DefaultTitle";
import clsx from 'clsx';
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { IRelatorio } from "../../interfaces/IRelatorio";
import cartaoNovaService from "../../services/cartaoNovaService";
import empresaNovaService from "../../services/empresaNovaService";
import { IEmpresas } from "../../interfaces/IEmpresas";
import { IClientes } from "../../interfaces/IClientes";
import clientesService from "../../services/ClientesService";
import regraConciliacaoService from "../../services/regraConciliacaoService";
import { formatarCnpj } from "../../utils/String";
import Swal from "sweetalert2";
import { useHistory, useParams } from "react-router-dom";
import * as XLSX from 'xlsx';


type SearchableSelectOption = { value: number; label: string };

function SearchableSelect({ value, onChange, options, placeholder, disabled }: {
    value: number;
    onChange: (val: number) => void;
    options: SearchableSelectOption[];
    placeholder: string;
    disabled?: boolean;
}) {
    const [open, setOpen] = useState(false);
    const [search, setSearch] = useState('');
    const containerRef = useRef<HTMLDivElement>(null);

    const filtered = useMemo(() => {
        if (!search.trim()) return options;
        const lower = search.toLowerCase();
        return options.filter(o => o.label.toLowerCase().includes(lower));
    }, [options, search]);

    const selectedLabel = options.find(o => o.value === value)?.label ?? placeholder;

    useEffect(() => {
        const handleClickOutside = (e: MouseEvent) => {
            if (containerRef.current && !containerRef.current.contains(e.target as Node)) {
                setOpen(false);
                setSearch('');
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <div ref={containerRef} style={{ position: 'relative' }}>
            <div
                className="form-select"
                style={{ cursor: disabled ? 'default' : 'pointer', color: value === 0 ? '#a1a5b7' : 'inherit' }}
                onClick={() => { if (!disabled) setOpen(o => !o); }}
            >
                {selectedLabel}
            </div>
            {open && (
                <div style={{
                    position: 'absolute', top: 'calc(100% + 4px)', left: 0, right: 0,
                    zIndex: 1050, background: '#fff', border: '1px solid #e4e6ef',
                    borderRadius: '0.475rem', boxShadow: '0 0 50px 0 rgba(82,63,105,0.15)',
                    display: 'flex', flexDirection: 'column'
                }}>
                    <div style={{ padding: '8px 8px 4px' }}>
                        <input
                            autoFocus
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="Buscar..."
                            value={search}
                            onChange={e => setSearch(e.target.value)}
                            onClick={e => e.stopPropagation()}
                        />
                    </div>
                    <div style={{ overflowY: 'auto', maxHeight: '240px' }}>
                        <div
                            className="px-4 py-2 text-muted"
                            style={{ cursor: 'pointer', fontSize: '0.9rem' }}
                            onClick={() => { onChange(0); setOpen(false); setSearch(''); }}
                        >
                            {placeholder}
                        </div>
                        {filtered.length === 0 ? (
                            <div className="px-4 py-2 text-muted" style={{ fontSize: '0.9rem' }}>
                                Nenhum resultado encontrado.
                            </div>
                        ) : (
                            filtered.map(option => (
                                <div
                                    key={option.value}
                                    className={`px-4 py-2${value === option.value ? ' bg-light-primary text-primary fw-semibold' : ''}`}
                                    style={{ cursor: 'pointer', fontSize: '0.9rem' }}
                                    onMouseEnter={e => { if (value !== option.value) (e.currentTarget as HTMLDivElement).style.background = '#f9f9f9'; }}
                                    onMouseLeave={e => { if (value !== option.value) (e.currentTarget as HTMLDivElement).style.background = ''; }}
                                    onClick={() => { onChange(option.value); setOpen(false); setSearch(''); }}
                                >
                                    {option.label}
                                </div>
                            ))
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}

export const GRUPOS_EVENTO: { key: string; label: string }[] = [
    { key: 'isFornecedor', label: 'Fornecedor' },
    { key: 'isTributo', label: 'Tributo' },
    { key: 'isBanco', label: 'Banco' },
    { key: 'isCaixa', label: 'Caixa' },
    { key: 'isSalario', label: 'Salário' },
    { key: 'isFolhaPagamento', label: 'Folha de Pagamento' },
    { key: 'isImobilizado', label: 'Imobilizado' },
    { key: 'isDepreciado', label: 'Depreciado' },
    { key: 'isEstoque', label: 'Estoque' },
    { key: 'isCapitalSocial', label: 'Capital Social' },
    { key: 'isCapitalSubscrever', label: 'Capital a Subscrever' },
    { key: 'isLucrosAcumulados', label: 'Lucros Acumulados' },
    { key: 'isPrejuizosAcumulados', label: 'Prejuízos Acumulados' },
    { key: 'isRetido', label: 'Retido' },
    { key: 'isEmprestimo', label: 'Empréstimo' },
    { key: 'isInvestimento', label: 'Investimento' },
    { key: 'isAdiantamento', label: 'Adiantamento' },
    { key: 'isDiferido', label: 'Diferido' },
    { key: 'isAjusteValorJusto', label: 'Ajuste a Valor Justo' },
    { key: 'isDesagio', label: 'Deságio' },
    { key: 'isDistribuicaoLucro', label: 'Distribuição de Lucro' },
    { key: 'isMutuo', label: 'Mútuo' },
    { key: 'isVendedorMercadoria', label: 'Vendedor de Mercadoria' },
    { key: 'isParcelamentoTributo', label: 'Parcelamento de Tributo' },
    { key: 'isClienteFornecedor', label: 'Cliente/Fornecedor' },
];

function FormRegra() {

    const { id } = useParams<{ id?: string }>();
    const history = useHistory();
    const { classes } = useLayout();
    const [regraSelecionada, setRegraSelecionada] = useState(0);
    const [todasAsContas, setTodasAsContas] = useState(false);
    const [contasSelecionadas, setContasSelecionadas] = useState<string[]>([]);
    const [chaves, setChaves] = useState<string[]>([]);
    const [chavesCredito, setChavesCredito] = useState<string[]>([]);
    const [chavesDebito, setChavesDebito] = useState<string[]>([]);
    const [novaChave, setNovaChave] = useState("");
    const [quantidadeMesesParaBaixa, setQuantidadeMesesParaBaixa] = useState<number>(1);
    const [diaParaBaixa, setDiaParaBaixa] = useState<number>(0);
    const [porcentagem, setPorcentagem] = useState<number>(100);
    const [removerNumeros, setRemoverNumeros] = useState(false);
    const [somenteEssaRegra, setSomenteEssaRegra] = useState(false);
    const [chavesPorTipoLancamento, setChavesPorTipoLancamento] = useState(false);
    const [executarNoInicio, setExecutarNoInicio] = useState(false);
    const [partesRemover, setPartesRemover] = useState<string[]>([]);
    const [novaParte, setNovaParte] = useState("");
    const [replacePatterns, setReplacePatterns] = useState<string[]>([]);
    const [novoReplacePattern, setNovoReplacePattern] = useState("");
    const [chavesComPadding, setChavesComPadding] = useState<string[]>([]);
    const [novaChaveComPadding, setNovaChaveComPadding] = useState("");
    const [empresaID, setEmpresaID] = useState<number>(0);
    const [contas, setContas] = useState<IRelatorio[]>([]);
    const [empresas, setEmpresas] = useState<IEmpresas[]>([]);
    const [clientes, setClientes] = useState<IClientes[]>([]);
    const [regras, setRegras] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [loadingAccounts, setLoadingAccounts] = useState(false);
    const [loadingConfig, setLoadingConfig] = useState(false);
    const [diasParaBaixa, setDiasParaBaixa] = useState<number[]>([]);
    const [filtroContas, setFiltroContas] = useState<string>('');
    const [grupoFiltro, setGrupoFiltro] = useState<string>('');
    const [empresasParaReplicar, setEmpresasParaReplicar] = useState<number[]>([]);
    const [gruposParaReplicar, setGruposParaReplicar] = useState<string[]>([]);
    const [loadingReplicacao, setLoadingReplicacao] = useState(false);
    const [filtroEmpresaReplicar, setFiltroEmpresaReplicar] = useState('');
    const [clienteFiltroReplicar, setClienteFiltroReplicar] = useState<number>(0);

    // COMPOSTO_POR_CHAVE
    const [chavesComposto, setChavesComposto] = useState<string[]>([]);
    const [novaChaveComposto, setNovaChaveComposto] = useState('');
    const [agruparPor, setAgruparPor] = useState<'provisao' | 'pagamento'>('provisao');
    const [diasParaBuscarBaixaComposto, setDiasParaBuscarBaixaComposto] = useState<number | undefined>(undefined);
    const [palavrasParaRemoverComposto, setPalavrasParaRemoverComposto] = useState<string[]>([]);
    const [novaPalavraParaRemoverComposto, setNovaPalavraParaRemoverComposto] = useState('');

    // ConciliarBlocoHistorico
    const [apenasNotasFiscaisBloco, setApenasNotasFiscaisBloco] = useState(false);
    const [blocoProvisao, setBlocoProvisao] = useState<number>(1);
    const [blocoPagamento, setBlocoPagamento] = useState<number>(1);

    const regraClasseSelecionada = regras.find(r => r.id === regraSelecionada)?.classe as string | undefined;

    const contasFiltradas = useMemo(() => {
        if (!filtroContas.trim()) return contas;
        const lower = filtroContas.toLowerCase();
        return contas.filter(c =>
            c.contaEmpresa.toLowerCase().includes(lower) ||
            (c.descricaoEmpresa || '').toLowerCase().includes(lower)
        );
    }, [contas, filtroContas]);

    const toggleChave = () => {
        if (novaChave.trim()) {
            setChaves([...chaves, novaChave.trim()]);
            setNovaChave("");
        }
    };

    const toggleChaveCredit = () => {
        if (novaChave.trim()) {
            setChavesCredito([...chaves, novaChave.trim()]);
            setNovaChave("");
        }
    };

    const toggleDiaParaBaixa = () => {
        if (diaParaBaixa > 0 && !diasParaBaixa.includes(diaParaBaixa)) {
            setDiasParaBaixa([...diasParaBaixa, diaParaBaixa]);
            setDiaParaBaixa(0);
        }
    };

    const toggleChaveDebit = () => {
        if (novaChave.trim()) {
            setChavesDebito([...chaves, novaChave.trim()]);
            setNovaChave("");
        }
    };

    const toggleParteRemover = () => {
        if (novaParte.trim()) {
            setPartesRemover([...partesRemover, novaParte.trim()]);
            setNovaParte("");
        }
    };

    const toggleReplacePattern = () => {
        if (novoReplacePattern.trim()) {
            setReplacePatterns([...replacePatterns, novoReplacePattern.trim()]);
            setNovoReplacePattern("");
        }
    };

    const toggleChaveComPadding = () => {
        if (novaChaveComPadding.trim()) {
            setChavesComPadding([...chavesComPadding, novaChaveComPadding.trim()]);
            setNovaChaveComPadding("");
        }
    };

    useEffect(() => {
        const load = async () => {
            if (empresaID <= 0) return;
            setLoadingAccounts(true);
            const resultContas = await cartaoNovaService.buscarCartoesPorEmpresa(empresaID);
            setContas(resultContas);
            setFiltroContas('');
            setLoadingAccounts(false);
        }

        load();
    }, [empresaID]);

    useEffect(() => {
        const load = async () => {
            setLoading(true);
            const [empresas, regras, clientes] = await Promise.all([
                empresaNovaService.buscarTodas(),
                regraConciliacaoService.getAllRules(),
                clientesService.obterTodosGeral(),
            ]);
            setEmpresas(empresas);
            setRegras(regras);
            setClientes(clientes);

            if (id) {
                const parseId = parseInt(id);
                const regra = await regraConciliacaoService.getById(parseId);

                if (!regra) {
                    Swal.fire({
                        text: 'Regra não foi encontrada.',
                        timer: 3000,
                        icon: 'error',
                        showConfirmButton: false
                    });

                    history.push('/parametrizacoes/regra/conciliacao');
                    return;
                }

                setEmpresaID(regra.empresaId);
                setRegraSelecionada(regra.regraConciliacaoId);
                setContasSelecionadas(regra.contas === "todas" ? [] : regra.contas.split(',').map((c: string) => c.trim()));
                setTodasAsContas(regra.contas === "todas");
                setSomenteEssaRegra(regra.somenteEssaRegra);
                setExecutarNoInicio(regra.executarNoInicio);

                if (regra.regraConciliacaoId === 19 && regra.parametros) {
                    const settings = JSON.parse(regra.parametros);
                    setChaves(settings.Keys || []);
                    const keysCredit = settings.KeysCredit || [];
                    setChavesCredito(keysCredit);
                    const keysDebit = settings.KeysDebit || [];
                    setChavesDebito(keysDebit);
                    setPorcentagem(settings.Percentage ?? 100);
                    setRemoverNumeros(settings.RemoveNumbers || false);
                    setPartesRemover(settings.KeysToRemove || []);
                    setReplacePatterns(settings.ReplacePatternBeforeCaughtNumber || []);
                    setChavesComPadding(settings.KeysComPadding || []);
                    setChavesPorTipoLancamento(keysCredit.length > 0 || keysDebit.length > 0);
                }

                if (regra.regraConciliacaoId === 24 && regra.parametros) {
                    const settings = JSON.parse(regra.parametros);
                    setDiasParaBaixa(settings.DaysForSearchTheLow || []);
                    setQuantidadeMesesParaBaixa(settings.MaxMonthsForSearchTheLow || 1);
                }

                if (regra.nomeRegra === 'COMPOSTO_POR_CHAVE' && regra.parametros) {
                    const settings = JSON.parse(regra.parametros);
                    setChavesComposto(settings.Keys || []);
                    setAgruparPor(settings.AgruparPor === 'pagamento' ? 'pagamento' : 'provisao');
                    setDiasParaBuscarBaixaComposto(settings.DiasParaBuscarBaixa ?? undefined);
                    setPalavrasParaRemoverComposto(settings.PalavrasParaRemover || []);
                }

                if (regra.nomeRegra === 'ConciliarBlocoHistorico' && regra.parametros) {
                    const settings = JSON.parse(regra.parametros);
                    setApenasNotasFiscaisBloco(settings.ApenasNotasFiscais || false);
                    setBlocoProvisao(settings.BlocoProvisao ?? 1);
                    setBlocoPagamento(settings.BlocoPagamento ?? 1);
                }

            }

            setLoading(false);
        }

        load();
    }, [id]);

    const buildJsonSettings = useCallback((): string | null => {
        if (regraSelecionada === 19) {
            return JSON.stringify({
                Keys: chaves,
                Percentage: porcentagem,
                RemoveNumbers: removerNumeros,
                KeysToRemove: partesRemover,
                ReplacePatternBeforeCaughtNumber: replacePatterns,
                KeysComPadding: chavesComPadding,
                KeysCredit: chavesCredito,
                KeysDebit: chavesDebito
            });
        }
        if (regraSelecionada === 24) {
            return JSON.stringify({
                DaysForSearchTheLow: diasParaBaixa,
                MaxMonthsForSearchTheLow: quantidadeMesesParaBaixa
            });
        }
        if (regraClasseSelecionada === 'COMPOSTO_POR_CHAVE') {
            return JSON.stringify({
                Keys: chavesComposto,
                AgruparPor: agruparPor,
                DiasParaBuscarBaixa: diasParaBuscarBaixaComposto ?? null,
                PalavrasParaRemover: palavrasParaRemoverComposto.length > 0 ? palavrasParaRemoverComposto : null
            });
        }
        if (regraClasseSelecionada === 'ConciliarBlocoHistorico') {
            return JSON.stringify({
                ApenasNotasFiscais: apenasNotasFiscaisBloco,
                BlocoProvisao: blocoProvisao,
                BlocoPagamento: blocoPagamento
            });
        }
        return null;
    }, [regraSelecionada, regraClasseSelecionada, chaves, porcentagem, removerNumeros, partesRemover, replacePatterns, chavesComPadding, chavesCredito, chavesDebito, diasParaBaixa, quantidadeMesesParaBaixa, chavesComposto, agruparPor, diasParaBuscarBaixaComposto, palavrasParaRemoverComposto, apenasNotasFiscaisBloco, blocoProvisao, blocoPagamento]);

    const saveRule = useCallback(async () => {
        if (empresaID <= 0 || regraSelecionada <= 0) {
            Swal.fire({
                text: 'Por favor selecione uma empresa e uma regra.',
                timer: 3000,
                icon: 'error',
                showConfirmButton: false
            });
            return;
        }

        if (regraSelecionada == 19 && (chaves.length === 0 && chavesCredito.length === 0 && chavesDebito.length === 0)) {
            Swal.fire({
                text: 'Por favor selecione uma chave para o histórico.',
                timer: 3000,
                icon: 'error',
                showConfirmButton: false
            });
            return;
        }

        if (regraSelecionada == 24 && diasParaBaixa.length === 0) {
            Swal.fire({
                text: 'Por favor selecione pelo menos um dia para buscar a baixa.',
                timer: 3000,
                icon: 'error',
                showConfirmButton: false
            });
            return;
        }

        if (regraClasseSelecionada === 'COMPOSTO_POR_CHAVE' && chavesComposto.length === 0) {
            Swal.fire({
                text: 'Por favor informe ao menos uma chave para buscar o número no histórico.',
                timer: 3000,
                icon: 'error',
                showConfirmButton: false
            });
            return;
        }

        if (regraClasseSelecionada === 'ConciliarBlocoHistorico' && (blocoProvisao < 1 || blocoPagamento < 1)) {
            Swal.fire({
                text: 'Por favor informe blocos válidos (a partir de 1) para provisão e pagamento.',
                timer: 3000,
                icon: 'error',
                showConfirmButton: false
            });
            return;
        }

        const regra = {
            idEmpresa: empresaID,
            idRegra: regraSelecionada,
            contas: todasAsContas ? [] : contasSelecionadas,
            todasContasClienteFornecedor: todasAsContas,
            somenteEssaRegra,
            executarNoInicio,
            jsonStringSettings: buildJsonSettings()
        } as any;

        try {
            if (id) {
                const parsedId = parseInt(id);
                await regraConciliacaoService.updateRule(parsedId, regra);
            } else {
                await regraConciliacaoService.saveRule(regra);
            }

            Swal.fire({
                text: 'Regra salva com sucesso.',
                timer: 3000,
                icon: 'success',
                showConfirmButton: false
            });

            history.push('/parametrizacoes/regra/conciliacao');
        } catch (error) {
            Swal.fire({
                text: 'Ocorreu um erro ao salvar a regra.',
                timer: 3000,
                icon: 'error',
                showConfirmButton: false
            });
        }

    }, [empresaID, regraSelecionada, contasSelecionadas, executarNoInicio, somenteEssaRegra, todasAsContas, id, buildJsonSettings]);

    const replicarRegra = useCallback(async () => {
        if (regraSelecionada <= 0) {
            Swal.fire({ text: 'Selecione uma regra antes de replicar.', icon: 'error', timer: 3000, showConfirmButton: false });
            return;
        }
        if (empresasParaReplicar.length === 0) {
            Swal.fire({ text: 'Selecione ao menos uma empresa para replicar.', icon: 'error', timer: 3000, showConfirmButton: false });
            return;
        }
        if (gruposParaReplicar.length === 0) {
            Swal.fire({ text: 'Selecione ao menos um grupo para definir as contas de cada empresa.', icon: 'error', timer: 3000, showConfirmButton: false });
            return;
        }

        setLoadingReplicacao(true);
        let criadas = 0;
        let semContas = 0;
        let erros = 0;

        for (const empId of empresasParaReplicar) {
            try {
                const contasEmpresa = await cartaoNovaService.buscarCartoesPorEmpresa(empId);
                const contasDoGrupo = contasEmpresa
                    .filter(c => gruposParaReplicar.some(g => !!(c as any)[g]))
                    .map(c => c.contaEmpresa);

                if (contasDoGrupo.length === 0) {
                    semContas++;
                    continue;
                }

                await regraConciliacaoService.saveRule({
                    idEmpresa: empId,
                    idRegra: regraSelecionada,
                    contas: contasDoGrupo,
                    todasContasClienteFornecedor: false,
                    somenteEssaRegra,
                    executarNoInicio,
                    jsonStringSettings: buildJsonSettings()
                });
                criadas++;
            } catch {
                erros++;
            }
        }

        setLoadingReplicacao(false);

        const partes: string[] = [];
        if (criadas > 0) partes.push(`${criadas} regra(s) criada(s) com sucesso`);
        if (semContas > 0) partes.push(`${semContas} empresa(s) sem contas no grupo selecionado`);
        if (erros > 0) partes.push(`${erros} erro(s)`);

        Swal.fire({
            text: partes.join(' · '),
            icon: erros > 0 ? 'warning' : 'success',
            timer: 5000,
            showConfirmButton: false
        });
    }, [regraSelecionada, empresasParaReplicar, gruposParaReplicar, somenteEssaRegra, executarNoInicio, buildJsonSettings]);

    const handleFileUpload = (e: any) => {
        setLoadingConfig(true);
        const file = e.target.files[0];
        const reader = new FileReader();

        reader.onload = (evt: any) => {
            const data = new Uint8Array(evt.target.result);
            const workbook = XLSX.read(data, { type: 'array' });

            const sheetNames = workbook.SheetNames;

            if (sheetNames.length === 0 || sheetNames.length < 3 || (!sheetNames.includes('Contas') || !sheetNames.includes('Chaves') || !sheetNames.includes('Remover'))) {
                Swal.fire({
                    text: 'O arquivo não contém planilhas válidas.',
                    timer: 3000,
                    icon: 'error',
                    showConfirmButton: false
                });
                setLoadingConfig(false);
                return;
            }

            const contas = workbook.Sheets['Contas'];
            const chaves = workbook.Sheets['Chaves'];
            const remover = workbook.Sheets['Remover'];

            const jsonContas = XLSX.utils.sheet_to_json(contas, { header: 1, defval: '' });
            const jsonChaves = XLSX.utils.sheet_to_json(chaves, { header: 1, defval: '' });
            const jsonRemover = XLSX.utils.sheet_to_json(remover, { header: 1, defval: '' });

            if (jsonChaves.length === 0 || jsonRemover.length === 0 || jsonContas.length === 0) {
                Swal.fire({
                    text: 'O arquivo não contém dados válidos.',
                    timer: 3000,
                    icon: 'error',
                    showConfirmButton: false
                });
                setLoadingConfig(false);
                return;
            }

            const contasSelecionadas = jsonContas.map((item: any) => item[0].toString().trim()).filter((item: string) => item !== '');
            const chavesSelecionadas = jsonChaves.map((item: any) => item[0].toString().trim()).filter((item: string) => item !== '');
            const partesRemoverSelecionadas = jsonRemover.map((item: any) => item[0].toString().trim()).filter((item: string) => item !== '');

            setContasSelecionadas(contasSelecionadas);
            setChaves(chavesSelecionadas);
            setPartesRemover(partesRemoverSelecionadas);
        };

        reader.readAsArrayBuffer(file);
        setLoadingConfig(false);
    };

    const regraDescricao = regras.find(f => f.id === regraSelecionada)?.descricao;

    return (
        <>
            <PageTitle breadcrumbs={[]}>Formulário Regra Conciliação</PageTitle>
            <div className='toolbar' id='kt_toolbar'>
                <div id='kt_toolbar_container' className={clsx(classes.toolbarContainer.join(' '), 'd-flex flex-stack')}>
                    <DefaultTitle />
                </div>
            </div>

            {loading ? (
                <div className="d-flex justify-content-center align-items-center py-10">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Carregando...</span>
                    </div>
                </div>
            ) : (
                <div className="row g-6">

                    {/* Card principal: Configuração geral */}
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header border-0 pt-6">
                                <div className="card-title">
                                    <h3 className="fw-bold m-0">Configuração Geral</h3>
                                </div>
                            </div>
                            <div className="card-body pt-4">
                                <div className="row g-6">
                                    <div className="col-md-6">
                                        <label className="form-label required fw-semibold">Empresa</label>
                                        <SearchableSelect
                                            value={empresaID}
                                            onChange={setEmpresaID}
                                            placeholder="Selecione uma empresa"
                                            options={empresas.map(e => ({
                                                value: e.id,
                                                label: e.cnpj
                                                    ? `${e.razaoSocial ?? ''} (${formatarCnpj(e.cnpj)})`
                                                    : (e.razaoSocial ?? '')
                                            }))}
                                        />
                                    </div>

                                    <div className="col-md-6">
                                        <label className="form-label required fw-semibold">Regra</label>
                                        <SearchableSelect
                                            value={regraSelecionada}
                                            onChange={setRegraSelecionada}
                                            placeholder="Selecione uma regra"
                                            options={regras.map(r => ({ value: r.id, label: r.classe }))}
                                            disabled={loadingConfig}
                                        />
                                    </div>

                                    {regraSelecionada > 0 && regraDescricao && (
                                        <div className="col-12">
                                            <div className="notice d-flex align-items-start bg-light-primary rounded border-primary border border-dashed p-5 gap-4">
                                                <i className="bi bi-info-circle-fill text-primary fs-2x flex-shrink-0 mt-1" />
                                                <div className="d-flex flex-column">
                                                    <span className="fw-bold text-gray-800 fs-6 mb-1">Como funciona esta regra</span>
                                                    <span className="text-gray-600 fs-7 lh-lg">{regraDescricao}</span>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Card de contas + opções */}
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header border-0 pt-6">
                                <div className="card-title">
                                    <h3 className="fw-bold m-0">Contas e Opções</h3>
                                </div>
                            </div>
                            <div className="card-body pt-4">
                                <div className="row g-6">

                                    {/* Coluna contas */}
                                    <div className="col-md-8">
                                        <label className="form-label fw-semibold">Contas</label>

                                        <div className="form-check mb-3">
                                            <input
                                                disabled={loadingAccounts || loadingConfig}
                                                type="checkbox"
                                                className="form-check-input"
                                                id="todasContas"
                                                checked={todasAsContas}
                                                onChange={(e) => {
                                                    setTodasAsContas(e.target.checked);
                                                    setContasSelecionadas(
                                                        e.target.checked ? [...contas.map((item) => item.contaEmpresa)] : []
                                                    );
                                                }}
                                            />
                                            <label className="form-check-label fw-semibold" htmlFor="todasContas">
                                                Todas as contas
                                            </label>
                                        </div>

                                        {!todasAsContas && (
                                            <>
                                                <input
                                                    type="text"
                                                    className="form-control mb-2"
                                                    placeholder="Filtrar contas por código ou descrição..."
                                                    value={filtroContas}
                                                    onChange={(e) => setFiltroContas(e.target.value)}
                                                    disabled={loadingAccounts || loadingConfig || empresaID <= 0}
                                                />
                                                {filtroContas && (
                                                    <span className="text-muted fs-7 mb-2 d-block">
                                                        {contasFiltradas.length} conta(s) exibida(s) — selecionadas: {contasSelecionadas.length}
                                                    </span>
                                                )}
                                                {contas.length > 0 && (
                                                    <div className="d-flex align-items-center gap-2 mb-2 flex-wrap">
                                                        <select
                                                            className="form-select form-select-sm"
                                                            style={{ width: 'auto', minWidth: '220px' }}
                                                            value={grupoFiltro}
                                                            onChange={e => setGrupoFiltro(e.target.value)}
                                                            disabled={loadingAccounts || loadingConfig}
                                                        >
                                                            <option value="">Selecionar por grupo...</option>
                                                            {GRUPOS_EVENTO
                                                                .filter(g => contas.some(c => !!(c as any)[g.key]))
                                                                .map(g => (
                                                                    <option key={g.key} value={g.key}>{g.label}</option>
                                                                ))
                                                            }
                                                        </select>
                                                        <button
                                                            className="btn btn-sm btn-light-primary"
                                                            disabled={!grupoFiltro || loadingAccounts || loadingConfig}
                                                            onClick={() => {
                                                                const doGrupo = contas.filter(c => !!(c as any)[grupoFiltro]).map(c => c.contaEmpresa);
                                                                setContasSelecionadas(prev => Array.from(new Set([...prev, ...doGrupo])));
                                                            }}
                                                        >
                                                            Marcar grupo
                                                        </button>
                                                        <button
                                                            className="btn btn-sm btn-light-danger"
                                                            disabled={!grupoFiltro || loadingAccounts || loadingConfig}
                                                            onClick={() => {
                                                                const doGrupo = new Set(contas.filter(c => !!(c as any)[grupoFiltro]).map(c => c.contaEmpresa));
                                                                setContasSelecionadas(prev => prev.filter(c => !doGrupo.has(c)));
                                                            }}
                                                        >
                                                            Desmarcar grupo
                                                        </button>
                                                        {grupoFiltro && (
                                                            <span className="text-muted fs-7">
                                                                {contas.filter(c => !!(c as any)[grupoFiltro]).length} conta(s) neste grupo
                                                            </span>
                                                        )}
                                                    </div>
                                                )}
                                            </>
                                        )}

                                        {loadingAccounts ? (
                                            <div className="d-flex align-items-center gap-2 py-3">
                                                <div className="spinner-border spinner-border-sm text-primary" role="status" />
                                                <span className="text-muted fs-7">Carregando contas...</span>
                                            </div>
                                        ) : (
                                            <select
                                                className="form-select"
                                                multiple
                                                disabled={todasAsContas || loadingAccounts || loadingConfig}
                                                value={contasSelecionadas}
                                                style={{ minHeight: '180px' }}
                                                onChange={(e) =>
                                                    setContasSelecionadas(
                                                        Array.from(e.target.selectedOptions, (opt) => opt.value)
                                                    )
                                                }
                                            >
                                                {contasFiltradas.map((conta) => (
                                                    <option key={conta.contaEmpresa} value={conta.contaEmpresa}>
                                                        {`${conta.contaEmpresa} — ${conta.descricaoEmpresa}`}
                                                    </option>
                                                ))}
                                            </select>
                                        )}

                                        {empresaID <= 0 && (
                                            <span className="text-muted fs-7 mt-2 d-block">Selecione uma empresa para carregar as contas.</span>
                                        )}
                                    </div>

                                    {/* Coluna opções */}
                                    <div className="col-md-4">
                                        <label className="form-label fw-semibold">Opções</label>
                                        <div className="d-flex flex-column gap-4 mt-2">
                                            <div className="form-check form-switch">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id="executaInicio"
                                                    checked={executarNoInicio}
                                                    onChange={(e) => setExecutarNoInicio(e.target.checked)}
                                                />
                                                <label className="form-check-label fw-semibold" htmlFor="executaInicio">
                                                    Executa no início
                                                </label>
                                            </div>
                                            <div className="form-check form-switch">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id="somenteRegra"
                                                    checked={somenteEssaRegra}
                                                    onChange={(e) => setSomenteEssaRegra(e.target.checked)}
                                                />
                                                <label className="form-check-label fw-semibold" htmlFor="somenteRegra">
                                                    Somente essa regra
                                                </label>
                                            </div>
                                            <div className="form-check form-switch">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id="removerNumeros"
                                                    checked={removerNumeros}
                                                    onChange={(e) => setRemoverNumeros(e.target.checked)}
                                                />
                                                <label className="form-check-label fw-semibold" htmlFor="removerNumeros">
                                                    Remover números do histórico
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Card regra 24 */}
                    {regraSelecionada === 24 && (
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header border-0 pt-6">
                                    <div className="card-title">
                                        <h3 className="fw-bold m-0">Configuração da Regra</h3>
                                    </div>
                                </div>
                                <div className="card-body pt-4">
                                    <div className="row g-6">
                                        <div className="col-md-6">
                                            <label className="form-label fw-semibold">Dias para buscar a baixa</label>
                                            <div className="input-group mb-3">
                                                <input
                                                    disabled={loadingConfig}
                                                    type="number"
                                                    className="form-control"
                                                    value={diaParaBaixa}
                                                    onChange={(e) => setDiaParaBaixa(Number(e.target.value))}
                                                />
                                                <button className="btn btn-primary" onClick={toggleDiaParaBaixa}>
                                                    Adicionar
                                                </button>
                                            </div>
                                            <div className="d-flex flex-column gap-2">
                                                {diasParaBaixa.map((chave, idx) => (
                                                    <div key={idx} className="d-flex align-items-center justify-content-between bg-light rounded px-4 py-2">
                                                        <span className="fw-semibold">{chave}</span>
                                                        <button
                                                            disabled={loadingConfig}
                                                            className="btn btn-sm btn-light-danger"
                                                            onClick={() => setDiasParaBaixa(diasParaBaixa.filter((_, i) => i !== idx))}
                                                        >
                                                            Remover
                                                        </button>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <label className="form-label fw-semibold">Quantidade máxima de meses para buscar baixa</label>
                                            <input
                                                disabled={loadingConfig}
                                                type="number"
                                                className="form-control"
                                                value={quantidadeMesesParaBaixa}
                                                onChange={(e) => setQuantidadeMesesParaBaixa(Number(e.target.value))}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Card regra 19 */}
                    {regraSelecionada === 19 && (
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header border-0 pt-6">
                                    <div className="card-title">
                                        <h3 className="fw-bold m-0">Configuração da Regra</h3>
                                    </div>
                                </div>
                                <div className="card-body pt-4">
                                    <div className="row g-6">

                                        {/* Arquivo de configuração */}
                                        <div className="col-md-6">
                                            <label className="form-label fw-semibold">Arquivo de configuração (.xlsx)</label>
                                            <input className="form-control" type="file" accept=".xlsx" onChange={handleFileUpload} />
                                            <span className="text-muted fs-7 mt-1 d-block">Planilhas esperadas: Contas, Chaves, Remover</span>
                                        </div>

                                        {/* Porcentagem */}
                                        <div className="col-md-6">
                                            <label className="form-label fw-semibold">Porcentagem de histórico (%)</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                min={0}
                                                max={100}
                                                value={porcentagem}
                                                onChange={(e) => setPorcentagem(parseInt(e.target.value))}
                                            />
                                        </div>

                                        {/* Chaves por tipo de lançamento */}
                                        <div className="col-12">
                                            <div className="separator separator-dashed mb-4" />
                                            <div className="form-check form-switch mb-4">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id="chavesPorTipoLancamento"
                                                    checked={chavesPorTipoLancamento}
                                                    onChange={(e) => setChavesPorTipoLancamento(e.target.checked)}
                                                    disabled={chaves.length > 0 || chavesCredito.length > 0 || chavesDebito.length > 0}
                                                />
                                                <label className="form-check-label fw-semibold" htmlFor="chavesPorTipoLancamento">
                                                    Chaves por tipo de lançamento
                                                </label>
                                            </div>
                                        </div>

                                        {chavesPorTipoLancamento ? (
                                            <>
                                                {/* Chaves crédito */}
                                                <div className="col-md-6">
                                                    <label className="form-label fw-semibold">Chaves no Histórico (Crédito)</label>
                                                    <div className="input-group mb-3">
                                                        <input
                                                            disabled={loadingConfig}
                                                            type="text"
                                                            className="form-control"
                                                            value={novaChave}
                                                            onChange={(e) => setNovaChave(e.target.value)}
                                                        />
                                                        <button className="btn btn-primary" onClick={toggleChaveCredit}>
                                                            Adicionar
                                                        </button>
                                                    </div>
                                                    <div className="d-flex flex-column gap-2">
                                                        {chavesCredito.map((chave, idx) => (
                                                            <div key={idx} className="d-flex align-items-center justify-content-between bg-light rounded px-4 py-2">
                                                                <span className="fw-semibold">{chave}</span>
                                                                <button disabled={loadingConfig} className="btn btn-sm btn-light-danger" onClick={() => setChavesCredito(chavesCredito.filter((_, i) => i !== idx))}>
                                                                    Remover
                                                                </button>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>

                                                {/* Chaves débito */}
                                                <div className="col-md-6">
                                                    <label className="form-label fw-semibold">Chaves no Histórico (Débito)</label>
                                                    <div className="input-group mb-3">
                                                        <input
                                                            disabled={loadingConfig}
                                                            type="text"
                                                            className="form-control"
                                                            value={novaChave}
                                                            onChange={(e) => setNovaChave(e.target.value)}
                                                        />
                                                        <button className="btn btn-primary" onClick={toggleChaveDebit}>
                                                            Adicionar
                                                        </button>
                                                    </div>
                                                    <div className="d-flex flex-column gap-2">
                                                        {chavesDebito.map((chave, idx) => (
                                                            <div key={idx} className="d-flex align-items-center justify-content-between bg-light rounded px-4 py-2">
                                                                <span className="fw-semibold">{chave}</span>
                                                                <button disabled={loadingConfig} className="btn btn-sm btn-light-danger" onClick={() => setChavesDebito(chavesDebito.filter((_, i) => i !== idx))}>
                                                                    Remover
                                                                </button>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </>
                                        ) : (
                                            <div className="col-md-6">
                                                <label className="form-label fw-semibold">Chaves no Histórico</label>
                                                <div className="input-group mb-3">
                                                    <input
                                                        disabled={loadingConfig}
                                                        type="text"
                                                        className="form-control"
                                                        value={novaChave}
                                                        onChange={(e) => setNovaChave(e.target.value)}
                                                    />
                                                    <button className="btn btn-primary" onClick={toggleChave}>
                                                        Adicionar
                                                    </button>
                                                </div>
                                                <div className="d-flex flex-column gap-2">
                                                    {chaves.map((chave, idx) => (
                                                        <div key={idx} className="d-flex align-items-center justify-content-between bg-light rounded px-4 py-2">
                                                            <span className="fw-semibold">{chave}</span>
                                                            <button disabled={loadingConfig} className="btn btn-sm btn-light-danger" onClick={() => setChaves(chaves.filter((_, i) => i !== idx))}>
                                                                Remover
                                                            </button>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}

                                        {/* Chaves com padding (ano + zeros) */}
                                        <div className="col-md-6">
                                            <label className="form-label fw-semibold">Chaves com padding (ano + zeros)</label>
                                            <div className="form-text mb-2">
                                                Use para âncoras cujo número vem com prefixo de ano e zeros à esquerda (ex.: NF 202500000001103), enquanto o outro lado grava só o número (ex.: PAGO 1103). O número é reduzido a 1103 antes de agrupar. Não repita aqui uma chave já listada em "Chaves no Histórico".
                                            </div>
                                            <div className="input-group mb-3">
                                                <input
                                                    disabled={loadingConfig}
                                                    type="text"
                                                    className="form-control"
                                                    value={novaChaveComPadding}
                                                    onChange={(e) => setNovaChaveComPadding(e.target.value)}
                                                    onKeyDown={(e) => e.key === 'Enter' && toggleChaveComPadding()}
                                                />
                                                <button disabled={loadingConfig} className="btn btn-primary" onClick={toggleChaveComPadding}>
                                                    Adicionar
                                                </button>
                                            </div>
                                            <div className="d-flex flex-column gap-2">
                                                {chavesComPadding.map((chave, idx) => (
                                                    <div key={idx} className="d-flex align-items-center justify-content-between bg-light rounded px-4 py-2">
                                                        <span className="fw-semibold">{chave}</span>
                                                        <button disabled={loadingConfig} className="btn btn-sm btn-light-danger" onClick={() => setChavesComPadding(chavesComPadding.filter((_, i) => i !== idx))}>
                                                            Remover
                                                        </button>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>

                                        {/* Partes a remover */}
                                        <div className="col-md-6">
                                            <label className="form-label fw-semibold">Partes do histórico a remover (% do histórico)</label>
                                            <div className="input-group mb-3">
                                                <input
                                                    disabled={loadingConfig}
                                                    type="text"
                                                    className="form-control"
                                                    value={novaParte}
                                                    onChange={(e) => setNovaParte(e.target.value)}
                                                />
                                                <button disabled={loadingConfig} className="btn btn-primary" onClick={toggleParteRemover}>
                                                    Adicionar
                                                </button>
                                            </div>
                                            <div className="d-flex flex-column gap-2">
                                                {partesRemover.map((parte, idx) => (
                                                    <div key={idx} className="d-flex align-items-center justify-content-between bg-light rounded px-4 py-2">
                                                        <span className="fw-semibold">{parte}</span>
                                                        <button disabled={loadingConfig} className="btn btn-sm btn-light-danger" onClick={() => setPartesRemover(partesRemover.filter((_, i) => i !== idx))}>
                                                            Remover
                                                        </button>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>

                                        {/* Chaves para remover antes de capturar */}
                                        <div className="col-md-6">
                                            <label className="form-label fw-semibold">Históricos para remover antes de buscar a chave</label>
                                            <div className="input-group mb-3">
                                                <input
                                                    disabled={loadingConfig}
                                                    type="text"
                                                    className="form-control"
                                                    value={novoReplacePattern}
                                                    onChange={(e) => setNovoReplacePattern(e.target.value)}
                                                    onKeyDown={(e) => e.key === 'Enter' && toggleReplacePattern()}
                                                />
                                                <button disabled={loadingConfig} className="btn btn-primary" onClick={toggleReplacePattern}>
                                                    Adicionar
                                                </button>
                                            </div>
                                            <div className="d-flex flex-column gap-2">
                                                {replacePatterns.map((pattern, idx) => (
                                                    <div key={idx} className="d-flex align-items-center justify-content-between bg-light rounded px-4 py-2">
                                                        <span className="fw-semibold">{pattern}</span>
                                                        <button disabled={loadingConfig} className="btn btn-sm btn-light-danger" onClick={() => setReplacePatterns(replacePatterns.filter((_, i) => i !== idx))}>
                                                            Remover
                                                        </button>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Card COMPOSTO_POR_CHAVE */}
                    {regraClasseSelecionada === 'COMPOSTO_POR_CHAVE' && (
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header border-0 pt-6">
                                    <div className="card-title">
                                        <h3 className="fw-bold m-0">Configuração da Regra — Composto por Chave</h3>
                                    </div>
                                </div>
                                <div className="card-body pt-4">
                                    <div className="row g-6">

                                        {/* Chaves */}
                                        <div className="col-md-6">
                                            <label className="form-label fw-semibold required">Chaves no Histórico</label>
                                            <span className="text-muted fs-7 d-block mb-2">
                                                Padrão (regex) que identifica o número chave no histórico do lançamento.
                                            </span>
                                            <div className="input-group mb-3">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Ex.: nf, nota fiscal, doc"
                                                    value={novaChaveComposto}
                                                    onChange={e => setNovaChaveComposto(e.target.value)}
                                                    onKeyDown={e => {
                                                        if (e.key === 'Enter' && novaChaveComposto.trim()) {
                                                            setChavesComposto([...chavesComposto, novaChaveComposto.trim()]);
                                                            setNovaChaveComposto('');
                                                        }
                                                    }}
                                                />
                                                <button
                                                    className="btn btn-primary"
                                                    onClick={() => {
                                                        if (novaChaveComposto.trim()) {
                                                            setChavesComposto([...chavesComposto, novaChaveComposto.trim()]);
                                                            setNovaChaveComposto('');
                                                        }
                                                    }}
                                                >
                                                    Adicionar
                                                </button>
                                            </div>
                                            <div className="d-flex flex-column gap-2">
                                                {chavesComposto.map((chave, idx) => (
                                                    <div key={idx} className="d-flex align-items-center justify-content-between bg-light rounded px-4 py-2">
                                                        <span className="fw-semibold">{chave}</span>
                                                        <button
                                                            className="btn btn-sm btn-light-danger"
                                                            onClick={() => setChavesComposto(chavesComposto.filter((_, i) => i !== idx))}
                                                        >
                                                            Remover
                                                        </button>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>

                                        {/* Agrupar por + dias */}
                                        <div className="col-md-6">
                                            <div className="mb-6">
                                                <label className="form-label fw-semibold required">Agrupar por</label>
                                                <span className="text-muted fs-7 d-block mb-2">
                                                    Define qual lado é agrupado pela chave. O lado oposto é buscado para fechar o valor.
                                                </span>
                                                <div className="d-flex gap-4 mt-1">
                                                    <div className="form-check">
                                                        <input
                                                            type="radio"
                                                            className="form-check-input"
                                                            id="agruparProvisao"
                                                            checked={agruparPor === 'provisao'}
                                                            onChange={() => setAgruparPor('provisao')}
                                                        />
                                                        <label className="form-check-label fw-semibold" htmlFor="agruparProvisao">
                                                            Por Provisão
                                                        </label>
                                                    </div>
                                                    <div className="form-check">
                                                        <input
                                                            type="radio"
                                                            className="form-check-input"
                                                            id="agruparPagamento"
                                                            checked={agruparPor === 'pagamento'}
                                                            onChange={() => setAgruparPor('pagamento')}
                                                        />
                                                        <label className="form-check-label fw-semibold" htmlFor="agruparPagamento">
                                                            Por Pagamento
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>

                                            <div>
                                                <label className="form-label fw-semibold">Dias para buscar a baixa (opcional)</label>
                                                <span className="text-muted fs-7 d-block mb-2">
                                                    Quantidade mínima de dias após a data do primeiro lançamento do grupo para buscar a contraparte. Deixe em branco para buscar em qualquer data.
                                                </span>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    min={0}
                                                    placeholder="Ex.: 5"
                                                    value={diasParaBuscarBaixaComposto ?? ''}
                                                    onChange={e => setDiasParaBuscarBaixaComposto(
                                                        e.target.value !== '' ? Number(e.target.value) : undefined
                                                    )}
                                                />
                                            </div>
                                        </div>

                                        {/* Palavras para remover do histórico */}
                                        <div className="col-12">
                                            <div className="separator separator-dashed mb-4" />
                                            <label className="form-label fw-semibold">Palavras para remover do histórico (opcional)</label>
                                            <span className="text-muted fs-7 d-block mb-2">
                                                Cada palavra será removida temporariamente do histórico antes da extração da chave numérica. O histórico original <strong>não é alterado</strong> — a remoção ocorre apenas durante a conciliação.
                                            </span>
                                            <div className="input-group mb-3">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Ex.: PGTO, REF, JAN"
                                                    value={novaPalavraParaRemoverComposto}
                                                    onChange={e => setNovaPalavraParaRemoverComposto(e.target.value)}
                                                    onKeyDown={e => {
                                                        if (e.key === 'Enter' && novaPalavraParaRemoverComposto.trim()) {
                                                            setPalavrasParaRemoverComposto([...palavrasParaRemoverComposto, novaPalavraParaRemoverComposto.trim()]);
                                                            setNovaPalavraParaRemoverComposto('');
                                                        }
                                                    }}
                                                />
                                                <button
                                                    className="btn btn-primary"
                                                    onClick={() => {
                                                        if (novaPalavraParaRemoverComposto.trim()) {
                                                            setPalavrasParaRemoverComposto([...palavrasParaRemoverComposto, novaPalavraParaRemoverComposto.trim()]);
                                                            setNovaPalavraParaRemoverComposto('');
                                                        }
                                                    }}
                                                >
                                                    Adicionar
                                                </button>
                                            </div>
                                            <div className="d-flex flex-wrap gap-2">
                                                {palavrasParaRemoverComposto.map((palavra, idx) => (
                                                    <span key={idx} className="badge badge-light-danger fs-7 d-inline-flex align-items-center gap-2 px-3 py-2">
                                                        {palavra}
                                                        <button
                                                            type="button"
                                                            className="btn-close btn-close-sm"
                                                            style={{ fontSize: '0.6rem' }}
                                                            onClick={() => setPalavrasParaRemoverComposto(palavrasParaRemoverComposto.filter((_, i) => i !== idx))}
                                                        />
                                                    </span>
                                                ))}
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Card ConciliarBlocoHistorico */}
                    {regraClasseSelecionada === 'ConciliarBlocoHistorico' && (
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header border-0 pt-6">
                                    <div className="card-title">
                                        <h3 className="fw-bold m-0">Configuração da Regra — Bloco no Histórico</h3>
                                    </div>
                                </div>
                                <div className="card-body pt-4">
                                    <div className="row g-6">

                                        {/* Apenas notas fiscais */}
                                        <div className="col-12">
                                            <div className="form-check form-switch mb-2">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id="apenasNotasFiscaisBloco"
                                                    checked={apenasNotasFiscaisBloco}
                                                    onChange={(e) => setApenasNotasFiscaisBloco(e.target.checked)}
                                                />
                                                <label className="form-check-label fw-semibold" htmlFor="apenasNotasFiscaisBloco">
                                                    Considerar apenas notas fiscais no histórico
                                                </label>
                                            </div>
                                            <span className="text-muted fs-7 d-block">
                                                Quando ativado, os blocos são os possíveis números de nota fiscal extraídos do histórico. Quando desativado, os blocos são as palavras do histórico separadas por espaço.
                                            </span>
                                        </div>

                                        <div className="col-12">
                                            <div className="separator separator-dashed" />
                                        </div>

                                        {/* Bloco provisão */}
                                        <div className="col-md-6">
                                            <label className="form-label fw-semibold required">Bloco da Provisão</label>
                                            <span className="text-muted fs-7 d-block mb-2">
                                                Posição do bloco (1 = primeiro) usada como chave no lado da provisão.
                                            </span>
                                            <input
                                                type="number"
                                                className="form-control"
                                                min={1}
                                                value={blocoProvisao}
                                                onChange={(e) => setBlocoProvisao(Number(e.target.value))}
                                            />
                                        </div>

                                        {/* Bloco pagamento */}
                                        <div className="col-md-6">
                                            <label className="form-label fw-semibold required">Bloco do Pagamento</label>
                                            <span className="text-muted fs-7 d-block mb-2">
                                                Posição do bloco (1 = primeiro) usada como chave no lado do pagamento.
                                            </span>
                                            <input
                                                type="number"
                                                className="form-control"
                                                min={1}
                                                value={blocoPagamento}
                                                onChange={(e) => setBlocoPagamento(Number(e.target.value))}
                                            />
                                        </div>

                                        {/* Aviso */}
                                        <div className="col-12">
                                            <div className="notice d-flex align-items-start bg-light-warning rounded border-warning border border-dashed p-4 gap-4">
                                                <i className="bi bi-exclamation-triangle-fill text-warning fs-2x flex-shrink-0 mt-1" />
                                                <span className="text-gray-700 fs-7 lh-lg">
                                                    Lançamentos cujo histórico não tenha blocos suficientes para alcançar a posição configurada são desconsiderados e permanecem pendentes.
                                                </span>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Card replicar para outras empresas */}
                    {!id && (
                        <div className="col-12">
                            <div className="card border border-dashed border-primary">
                                <div className="card-header border-0 pt-6">
                                    <div className="card-title d-flex flex-column align-items-start gap-1">
                                        <h3 className="fw-bold m-0">Replicar para Outras Empresas</h3>
                                        <span className="text-muted fs-7">
                                            Opcional — cria a mesma regra em múltiplas empresas usando as contas do grupo selecionado para cada uma.
                                        </span>
                                    </div>
                                </div>
                                <div className="card-body pt-4">
                                    <div className="row g-6">

                                        {/* Grupos */}
                                        <div className="col-md-5">
                                            <label className="form-label fw-semibold">Grupos de contas</label>
                                            <span className="text-muted fs-7 d-block mb-3">
                                                Para cada empresa, serão usadas as contas que pertencem a qualquer um dos grupos marcados.
                                            </span>
                                            <div className="d-flex flex-wrap gap-x-4 gap-y-2" style={{ gap: '8px 20px' }}>
                                                {GRUPOS_EVENTO.map(g => (
                                                    <div key={g.key} className="form-check">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            id={`grupo-rep-${g.key}`}
                                                            checked={gruposParaReplicar.includes(g.key)}
                                                            onChange={e => {
                                                                if (e.target.checked) {
                                                                    setGruposParaReplicar(prev => [...prev, g.key]);
                                                                } else {
                                                                    setGruposParaReplicar(prev => prev.filter(k => k !== g.key));
                                                                }
                                                            }}
                                                        />
                                                        <label className="form-check-label" htmlFor={`grupo-rep-${g.key}`}>
                                                            {g.label}
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>

                                        {/* Empresas */}
                                        <div className="col-md-7">
                                            <label className="form-label fw-semibold">Empresas</label>
                                            <div className="d-flex gap-2 mb-2">
                                                <select
                                                    className="form-select form-select-sm"
                                                    value={clienteFiltroReplicar}
                                                    onChange={e => {
                                                        setClienteFiltroReplicar(Number(e.target.value));
                                                        setFiltroEmpresaReplicar('');
                                                    }}
                                                >
                                                    <option value={0}>Todos os clientes</option>
                                                    {clientes
                                                        .slice()
                                                        .sort((a, b) => (a.razaoSocial ?? '').localeCompare(b.razaoSocial ?? ''))
                                                        .map(c => (
                                                            <option key={c.id} value={c.id}>
                                                                {c.razaoSocial}
                                                            </option>
                                                        ))
                                                    }
                                                </select>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    placeholder="Filtrar por nome..."
                                                    value={filtroEmpresaReplicar}
                                                    onChange={e => setFiltroEmpresaReplicar(e.target.value)}
                                                />
                                            </div>
                                            <div style={{ maxHeight: '240px', overflowY: 'auto', border: '1px solid #e4e6ef', borderRadius: '0.475rem', padding: '8px' }}>
                                                {empresas
                                                    .filter(e => e.id !== empresaID)
                                                    .filter(e => clienteFiltroReplicar === 0 || e.clienteID === clienteFiltroReplicar)
                                                    .filter(e => !filtroEmpresaReplicar || (e.razaoSocial ?? '').toLowerCase().includes(filtroEmpresaReplicar.toLowerCase()))
                                                    .map(e => (
                                                        <div key={e.id} className="form-check mb-1">
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input"
                                                                id={`emp-rep-${e.id}`}
                                                                checked={empresasParaReplicar.includes(e.id)}
                                                                onChange={ev => {
                                                                    if (ev.target.checked) {
                                                                        setEmpresasParaReplicar(prev => [...prev, e.id]);
                                                                    } else {
                                                                        setEmpresasParaReplicar(prev => prev.filter(i => i !== e.id));
                                                                    }
                                                                }}
                                                            />
                                                            <label className="form-check-label" htmlFor={`emp-rep-${e.id}`}>
                                                                {e.razaoSocial}
                                                            </label>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                            <div className="d-flex align-items-center gap-3 mt-2 flex-wrap">
                                                <button
                                                    className="btn btn-sm btn-light"
                                                    onClick={() => setEmpresasParaReplicar(
                                                        empresas
                                                            .filter(e => e.id !== empresaID)
                                                            .filter(e => clienteFiltroReplicar === 0 || e.clienteID === clienteFiltroReplicar)
                                                            .filter(e => !filtroEmpresaReplicar || (e.razaoSocial ?? '').toLowerCase().includes(filtroEmpresaReplicar.toLowerCase()))
                                                            .map(e => e.id)
                                                    )}
                                                >
                                                    Selecionar visíveis
                                                </button>
                                                <button
                                                    className="btn btn-sm btn-light"
                                                    onClick={() => setEmpresasParaReplicar([])}
                                                >
                                                    Limpar seleção
                                                </button>
                                                <span className="text-muted fs-7">{empresasParaReplicar.length} empresa(s) selecionada(s)</span>
                                            </div>
                                        </div>

                                        {/* Botão replicar */}
                                        <div className="col-12">
                                            <div className="separator separator-dashed mb-4" />
                                            <button
                                                className="btn btn-primary"
                                                onClick={replicarRegra}
                                                disabled={loadingReplicacao || empresasParaReplicar.length === 0 || gruposParaReplicar.length === 0 || regraSelecionada <= 0}
                                            >
                                                {loadingReplicacao ? (
                                                    <>
                                                        <span className="spinner-border spinner-border-sm me-2" role="status" />
                                                        Replicando...
                                                    </>
                                                ) : (
                                                    <>
                                                        <i className="bi bi-diagram-3 me-2" />
                                                        Replicar Regra ({empresasParaReplicar.length} empresa{empresasParaReplicar.length !== 1 ? 's' : ''})
                                                    </>
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Botões */}
                    <div className="col-12">
                        <div className="d-flex justify-content-end gap-3">
                            <button
                                className="btn btn-light"
                                onClick={() => history.goBack()}
                                disabled={loadingConfig}
                            >
                                Voltar
                            </button>
                            <button
                                className="btn btn-success"
                                onClick={() => saveRule()}
                                disabled={loadingConfig}
                            >
                                {loadingConfig ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2" role="status" />
                                        Salvando...
                                    </>
                                ) : 'Salvar Regra'}
                            </button>
                        </div>
                    </div>

                </div>
            )}
        </>
    );
}

export default FormRegra;
